export const handleBold = (setIsBold) => {
    const isCurrentlyBold = document.queryCommandState("bold");
    setIsBold(!isCurrentlyBold);
    document.execCommand("bold");
};

export const handleItalic = (setIsItalic) => {
    const isCurrentlyItalic = document.queryCommandState("italic");
    setIsItalic(!isCurrentlyItalic);
    document.execCommand("italic");
};

export const handleUnderline = (setIsUnderline) => {
    const isCurrentlyUnderline = document.queryCommandState("underline");
    setIsUnderline(!isCurrentlyUnderline);
    document.execCommand("underline");
};

export const handleList = (setIsList) => {
    const isCurrentInsertUnorderedList = document.queryCommandState("insertUnorderedList");
    setIsList(!isCurrentInsertUnorderedList);
    document.execCommand("insertUnorderedList");
};

export const handleOrderedList = (setListNumber) => {
    const isCurrentInsertOrderedList = document.queryCommandState("insertOrderedList");
    setListNumber(!isCurrentInsertOrderedList);
    document.execCommand("insertOrderedList");
};
